<template>
  <div id="casestudyFooter" class="grid grid__item_span-12 p0 m0 clear">
    <div class="inner grid grid__item_span-9 clear" :id="item.pageID">
      <p class="txtWhite grid grid__item_span-12 m0 p0">Can't get enough?</p>
      <h2 class="txtWhite grid grid__item_span-12 m0 p0">{{item.pageClient}} - {{item.pageTitle}}</h2>
      <router-link :to="{ name: item.slug.name, params: { slug: item.slug.url, id: item.slug.id }}" :key="item.slug.id"><p class="txtWhite grid grid__item_span-12 m0 p0"> 
        <span v-if="item.cta">{{item.cta}}</span>
        <span v-else>Take a look.</span>
      </p></router-link>
    </div>
  </div>

</template> 

<script>

var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'Headline',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    addClass (state) {
      // console.log('running')
      // console.log(state)
      var footerState = state
      var projectWrap = document.getElementById('casestudyFooter')
      // var projectFooter = document.getElementById('casestudyFooter')
      // var wrap = document.getElementById('wrap')
      if (footerState === 'YES') {
        // console.log('this')
        // wrap.style.backgroundColor = '#141719'
        // projectFooter.style.position = 'fixed'
        projectWrap.classList.add('openFooter')
      } else {
        // console.log('that')
        // wrap.style.backgroundColor = '#EFF0F1'
        // projectFooter.style.position = 'static'
        projectWrap.classList.remove('openFooter')
      }
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      // var projectFooter = document.getElementById('casestudyFooter')
      var state = ''
      if (visible === true) {
        // console.log('YES')
        state = 'YES'
        // console.log(state)
        return this.addClass(state)
      } else {
        // console.log('no luck')
        state = 'NO'
        // console.log(state)
        return this.addClass(state)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/projectFooter.vue